var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconReply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1494_202191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833374,
    y: 0.179199,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1494_202191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16675 7.51245C6.35564 7.51245 6.51397 7.44856 6.64175 7.32079C6.76953 7.19301 6.83341 7.03467 6.83341 6.84578C6.83341 6.6569 6.76953 6.49856 6.64175 6.37078C6.51397 6.24301 6.35564 6.17912 6.16675 6.17912C5.97786 6.17912 5.81953 6.24301 5.69175 6.37078C5.56397 6.49856 5.50008 6.6569 5.50008 6.84578C5.50008 7.03467 5.56397 7.19301 5.69175 7.32079C5.81953 7.44856 5.97786 7.51245 6.16675 7.51245ZM8.83341 7.51245C9.0223 7.51245 9.18064 7.44856 9.30842 7.32079C9.43619 7.19301 9.50008 7.03467 9.50008 6.84578C9.50008 6.6569 9.43619 6.49856 9.30842 6.37078C9.18064 6.24301 9.0223 6.17912 8.83341 6.17912C8.64453 6.17912 8.48619 6.24301 8.35842 6.37078C8.23064 6.49856 8.16675 6.6569 8.16675 6.84578C8.16675 7.03467 8.23064 7.19301 8.35842 7.32079C8.48619 7.44856 8.64453 7.51245 8.83341 7.51245ZM11.5001 7.51245C11.689 7.51245 11.8473 7.44856 11.9751 7.32079C12.1029 7.19301 12.1667 7.03467 12.1667 6.84578C12.1667 6.6569 12.1029 6.49856 11.9751 6.37078C11.8473 6.24301 11.689 6.17912 11.5001 6.17912C11.3112 6.17912 11.1529 6.24301 11.0251 6.37078C10.8973 6.49856 10.8334 6.6569 10.8334 6.84578C10.8334 7.03467 10.8973 7.19301 11.0251 7.32079C11.1529 7.44856 11.3112 7.51245 11.5001 7.51245ZM2.16675 14.8458V2.84578C2.16675 2.47912 2.2973 2.16523 2.55841 1.90412C2.81953 1.64301 3.13341 1.51245 3.50008 1.51245H14.1667C14.5334 1.51245 14.8473 1.64301 15.1084 1.90412C15.3695 2.16523 15.5001 2.47912 15.5001 2.84578V10.8458C15.5001 11.2125 15.3695 11.5263 15.1084 11.7875C14.8473 12.0486 14.5334 12.1791 14.1667 12.1791H4.83341L2.16675 14.8458ZM4.26675 10.8458H14.1667V2.84578H3.50008V11.5958L4.26675 10.8458Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconReply);
export default __webpack_public_path__ + "static/media/profile-icon-reply.f11b380eac0b63c0a017aab029c547ff.svg";
export { ForwardRef as ReactComponent };